export default __webpack_public_path__ + "static/media/solucao-10.40b46b15.webp";